// Frontend-only mock quality scoring influenced by tone, mode, persona, and complexity
export function generateQualityScore({ tone = 'Formal', mode = 'Draft Clause', persona = 'Analyst', complexity = 'Medium' } = {}) {
  // base scores
  let clarity = 70
  let completeness = 65
  let jurisdictionRelevance = 60

  // Tone influence
  if (tone === 'Concise') {
    clarity += 5
    completeness -= 10
  } else if (tone === 'Detailed') {
    clarity -= 5
    completeness += 10
  }

  // Mode influence
  if (mode === 'Explain') {
    clarity += 10
    completeness += 5
  } else if (mode === 'Rewrite') {
    clarity += 5
  } else if (mode === 'Draft Clause') {
    completeness += 10
    jurisdictionRelevance += 5
  }

  // Persona adjustments
  if (persona === 'General Counsel') {
    completeness += 10
    jurisdictionRelevance += 10
  } else if (persona === 'Compliance Officer') {
    jurisdictionRelevance += 15
    completeness += 5
  } else if (persona === 'Regulator') {
    jurisdictionRelevance += 20
    clarity -= 5
  } else if (persona === 'Academic') {
    clarity += 5
    completeness -= 5
  }

  // Complexity reduces scores
  if (complexity === 'High') {
    clarity -= 10
    completeness -= 10
    jurisdictionRelevance += 5
  } else if (complexity === 'Low') {
    clarity += 5
    completeness += 5
  }

  // clamp 0-100 and random small variation
  const clamp = (v) => Math.max(0, Math.min(100, Math.round(v + (Math.random()*6 - 3))))

  return {
    clarity: clamp(clarity),
    completeness: clamp(completeness),
    jurisdictionRelevance: clamp(jurisdictionRelevance),
  }
}
